import { useApi, useApiAWS } from '@/composables/useApi'

const api = useApi()
const apiAws = useApiAWS()
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchUsers(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        api.get('get/usuarios', { params: queryParams })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchUser(ctx, { id }) {
      return new Promise((resolve, reject) => {
        api.get(`/usuarioAdmin/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    addUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        api.post('/cadNovoCliente', userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatedUser(ctx, userData) {
      return new Promise((resolve, reject) => {
        api.post(`/cadNovoCliente/${userData.id}`, userData)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

    deleteUser(ctx, userId) {
      return new Promise((resolve, reject) => {
        api.delete(`/usuario/${userId}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    deleteUserAws(ctx, userFileKey) {
      return new Promise((resolve, reject) => {
        apiAws.delete('/remover-folder', {
          params: {
            folder_key_name: userFileKey,
          },
        })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    get_permissionUserById(ctx, { id }) {
      return new Promise((resolve, reject) => {
        api.get(`/permissionUserById/${id}`)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  },
}
